import React from 'react';
import './Social.scss';
import LogIn from '../LogIn/LogIn';

function Social({ origin }) {
  return (
    <div className={origin === 'cnn' ? 'social' : `social social-${origin}`}>
      {origin === 'cnn' && (
        <a href="https://www.cnn.com/" aria-label="CNN" target='_blank' rel="noopener noreferrer">
          <svg
            className="cnn-badge-icon"
            width="200"
            height="94"
            viewBox="0 0 200 94"
            xmlns="http://www.w3.org/2000/svg"
            xmlnsXlink="http://www.w3.org/1999/xlink"
          >
            <defs>
              <path id="prefix__a" d="M0 .346h199.949v92.268H0z"></path>
              <path id="prefix__c" d="M.072 0h169.645v77.861H.072z"></path>
            </defs>
            <g fill="none" fillRule="evenodd">
              <g transform="translate(0 .386)">
                <mask id="prefix__b" fill="#fff">
                  <use xlinkHref="#prefix__a"></use>
                </mask>
                <path
                  d="M188.597.346v74.848c0 2.973-1.865 5.476-4.64 6.231a6.285 6.285 0 0 1-1.64.217c-2.113 0-4.547-1.05-6.308-4.032-.096-.162-7.065-12.146-17.687-30.412-8.58-14.757-17.453-30.015-17.607-30.276-.979-1.66-2.34-2.439-3.646-2.084-1.11.302-1.827 1.315-1.827 2.582v57.774c0 2.973-1.866 5.477-4.642 6.231-2.373.645-5.705-.019-7.946-3.815l-16.135-27.744A236232.22 236232.22 0 0 0 87.36 16.922c-.982-1.663-2.357-2.442-3.68-2.082-.852.231-1.846 1.046-1.846 2.58v56.516c0 3.72-3.276 6.982-7.01 6.982H46.062c-19.132 0-34.697-15.525-34.697-34.61S26.93 11.696 46.063 11.696H61V.346H46.076C20.629.346 0 20.923 0 46.308 0 71.692 20.63 92.27 46.076 92.27h29.039c11.04.007 18.139-6.446 18.124-18.347V47.706s18.524 31.834 19.374 33.275c11.76 19.925 33.98 11.69 33.982-5.462V47.706s18.523 31.834 19.373 33.275c11.76 19.925 33.981 11.69 33.981-5.462V.346h-11.352z"
                  fill="#FFF"
                  mask="url(#prefix__b)"
                ></path>
              </g>
              <g transform="translate(15.087 .386)">
                <mask id="prefix__d" fill="#fff">
                  <use xlinkHref="#prefix__c"></use>
                </mask>
                <path
                  d="M.072 46.308c0 16.998 13.864 30.827 30.904 30.827h28.761c1.813 0 3.218-1.72 3.218-3.2V17.42c0-2.972 1.865-5.477 4.64-6.23 2.374-.646 5.707.018 7.948 3.814.12.204 9.804 16.858 19.17 32.963 8.223 14.142 15.99 27.499 16.124 27.727.98 1.662 2.357 2.44 3.68 2.08.85-.23 1.845-1.045 1.845-2.58V17.42c0-2.976 1.858-5.481 4.623-6.233 2.359-.64 5.674.026 7.913 3.817.114.193 8.616 14.815 17.618 30.296l17.675 30.392c.982 1.663 2.358 2.443 3.68 2.083.852-.231 1.846-1.046 1.846-2.58V.345h-11.404v44.562s-18.524-31.833-19.375-33.274c-11.76-19.926-33.98-11.691-33.98 5.462v27.812S86.434 13.075 85.584 11.634C73.824-8.292 51.604-.057 51.603 17.096V62.68c.006 1.658-1.244 3.102-3.063 3.106H31.098c-10.784 0-19.526-8.72-19.526-19.478 0-10.758 8.742-19.478 19.526-19.478h14.815V15.48H30.976C13.936 15.48.072 29.31.072 46.308"
                  fill="#FFF"
                  mask="url(#prefix__d)"
                ></path>
              </g>
            </g>
          </svg>
          {/* <svg
            className="cnn-badge-icon"
            viewBox="0 0 240 240"
            fill="#CC0000"
            xmlns="https://www.w3.org/2000/svg"
            aria-hidden="true"
          >
            <rect x="0" y="0" width="100%" height="100%" fill="#fff"></rect>
            <path
              d="M.31-.07v240h240V-.07ZM86.54,135.29V92.51c0-16.1,20.81-23.83,31.82-5.12.8,1.35,18.14,31.22,18.14,31.22V92.51c0-16.1,20.8-23.83,31.81-5.12.8,1.35,18.14,31.22,18.14,31.22V76.79h10.38V147a2.11,2.11,0,0,1-1.51,2.14c-1.1.3-2.26-.38-3.11-1.82-.17-.28-9-15.46-17.48-30.13L159.17,90.4c-2.18-3.7-5.43-4.35-7.74-3.72a6.23,6.23,0,0,0-4.55,6.13V147a2.12,2.12,0,0,1-1.51,2.14c-1.11.3-2.27-.38-3.11-1.82-.15-.25-8.34-14.36-16.25-28-10.08-17.38-16.7-28.78-16.8-28.95-2.18-3.71-5.44-4.35-7.77-3.72a6.24,6.24,0,0,0-4.56,6.13v53.05a2.9,2.9,0,0,1-2.72,2.71H67.23a28.64,28.64,0,0,1,0-57.28h14v10.36H67.35a18.28,18.28,0,1,0,0,36.56H83.68A2.84,2.84,0,0,0,86.54,135.29Zm124.77,12.05c0,16.1-20.81,23.83-31.82,5.13-.79-1.35-18.14-31.23-18.14-31.23v26.1c0,16.1-20.8,23.83-31.81,5.13-.8-1.35-18.14-31.23-18.14-31.23v24.61c0,11.17-6.63,17.22-17,17.22H67.25a43.14,43.14,0,0,1,0-86.28h14V87.15h-14a32.78,32.78,0,1,0,0,65.56H94.16a7,7,0,0,0,6.86-6.85V92.81a2.1,2.1,0,0,1,1.51-2.13c1.1-.3,2.26.38,3.11,1.82l16.79,28.93c9.76,16.83,16.17,27.88,16.25,28,2.19,3.7,5.45,4.35,7.78,3.71A6.22,6.22,0,0,0,151,147V92.82a2.11,2.11,0,0,1,1.49-2.14c1.09-.3,2.24.38,3.08,1.82l15.56,26.81,17.49,30.15c1.71,2.9,4.09,3.93,6.16,3.93a6,6,0,0,0,1.61-.22A6.23,6.23,0,0,0,201,147V76.79h10.34Z"
              transform="translate(-0.31 0.07)"
            ></path>
          </svg> */}
        </a>
      )}

      <div className="social__links">
        <div className="social__links__media">
          <a href="https://www.cnn.com/video">Watch</a>
          <a href="https://www.cnn.com/audio">Listen</a>
          <a href="https://www.cnn.com/videos/live">Live TV</a>
        </div>
        <span className="social__links__copy">
          FOLLOW CNN{origin === 'politics' && ' POLITICS'}
        </span>

        <ul className="social__links__icons">
          <li>
            <a
              href={
                origin === 'cnn'
                  ? 'https://www.facebook.com/cnn/'
                  : 'https://www.facebook.com/cnnpolitics'
              }
              target="_blank"
              rel="noopener noreferrer"
              data-icon="facebook"
              aria-label="Visit us on Facebook"
              title="Visit us on Facebook"
            >
              <svg
                className="social__links__icons-icon"
                viewBox="0 0 64 64"
                fill="rgb(230, 230, 230)"
                xmlns="https://www.w3.org/2000/svg"
                aria-hidden="true"
              >
                <path d="M56,5.1H8c-1.6,0-3,1.4-3,3v48.8c0,1.7,1.3,3,3,3h25.9V38.7h-7v-8.3h7v-6.1 c0-7.1,4.3-10.9,10.5-10.9c3,0,5.9,0.2,6.7,0.3v7.7h-4.7c-3.4,0-4.1,1.6-4.1,4v5h8.1l-1,8.3h-7v21.2H56c1.6,0,3-1.4,3-3V8.1 C59,6.4,57.7,5.1,56,5.1"></path>
              </svg>
            </a>
          </li>
          <li>
            <a
              href={
                origin === 'cnn' ? 'https://twitter.com/CNN' : 'https://twitter.com/cnnpolitics'
              }
              target="_blank"
              rel="noopener noreferrer"
              data-icon="X"
              aria-label="Visit us on X"
              title="Visit us on X"
            >
              <svg
                className="social__links__icons-icon"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="https://www.w3.org/2000/svg"
                aria-hidden="true"
              >
                <path
                  fill="rgb(230, 230, 230)"
                  d="M13.903 10.469 21.348 2h-1.764l-6.465 7.353L7.955 2H2l7.808 11.12L2 22h1.764l6.828-7.765L16.044 22H22l-8.097-11.531Zm-2.417 2.748-.791-1.107L4.4 3.3h2.71l5.08 7.11.791 1.107 6.604 9.242h-2.71l-5.389-7.542Z"
                ></path>
              </svg>
            </a>
          </li>
          <li>
            <a
              href={
                origin === 'cnn'
                  ? 'https://www.instagram.com/CNN/'
                  : 'https://www.instagram.com/cnnpolitics/'
              }
              target="_blank"
              rel="noopener noreferrer"
              data-icon="instagram"
              aria-label="Visit us on Instagram"
              title="Visit us on Instagram"
              color="#0C0C0C"
            >
              <svg
                className="social__links__icons-icon social__links__icons-icon--insta"
                width="64"
                height="64"
                viewBox="0 0 64 64"
                fill="rgb(230, 230, 230)"
                xmlns="https://www.w3.org/2000/svg"
                aria-hidden="true"
              >
                <path d="M47,13.2c-1.9,0-3.5,1.6-3.5,3.6s1.6,3.6,3.5,3.6s3.5-1.6,3.5-3.6S49,13.2,47,13.2 L47,13.2z M31.9,23c-5.1,0-9.3,4.3-9.3,9.5s4.2,9.5,9.3,9.5s9.3-4.3,9.3-9.5S37,23,31.9,23L31.9,23z M31.9,46.7 c-7.7,0-14-6.4-14-14.2s6.3-14.2,14-14.2s14,6.4,14,14.2S39.6,46.7,31.9,46.7L31.9,46.7z M15.7,8.8c-3.9,0-7,3.2-7,7.1v33.2 c0,3.9,3.1,7.1,7,7.1h32.7c3.9,0,7-3.2,7-7.1V15.9c0-3.9-3.1-7.1-7-7.1C48.4,8.8,15.7,8.8,15.7,8.8z M48.3,60.9H15.7 C9.2,60.9,4,55.6,4,49.1V15.9C4,9.4,9.2,4.1,15.7,4.1h32.7C54.8,4.1,60,9.4,60,15.9v33.2C60,55.6,54.8,60.9,48.3,60.9L48.3,60.9z"></path>
              </svg>
            </a>
          </li>
          <li className={origin === 'cnn' ? '' : 'social__links__icons__list'}>
            <a
              href="https://www.tiktok.com/@cnn?lang=en"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Visit us on TikTok"
              title="Visit us on TikTok"
            >
              <svg
                className="social__links__icons-icon"
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                aria-hidden="true"
              >
                <path
                  d="M18.1156 6.00883C17.038 5.30649 16.2609 4.18226 16.0181 2.8724C15.9659 2.58946 15.9368 2.29799 15.9368 2H12.4984L12.4929 15.7798C12.4352 17.3229 11.165 18.5616 9.60828 18.5616C9.12417 18.5616 8.66866 18.4407 8.26732 18.2295C7.34726 17.7454 6.71767 16.7811 6.71767 15.6715C6.71767 14.0777 8.01448 12.7808 9.60778 12.7808C9.90527 12.7808 10.1907 12.83 10.4606 12.9143V9.40412C10.1812 9.36599 9.89724 9.34241 9.60778 9.34241C6.11818 9.34241 3.27924 12.1814 3.27924 15.6715C3.27924 17.8126 4.34879 19.7074 5.98122 20.8532C7.00914 21.5751 8.2598 22 9.60828 22C13.0979 22 15.9368 19.1611 15.9368 15.6715V8.68372C17.2853 9.65144 18.9378 10.2218 20.7207 10.2218V6.7834C19.7605 6.7834 18.8661 6.49796 18.1156 6.00883Z"
                  fill="white"
                ></path>
              </svg>
            </a>
          </li>
          <li className={origin === 'cnn' ? '' : 'social__links__icons__list'}>
            <a
              href="https://www.linkedin.com/company/cnn"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Visit us on LinkedIn"
              title="Visit us on LinkedIn"
            >
              <svg
                className="social__links__icons-icon"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="#e6e6e6"
                xmlns="http://www.w3.org/2000/svg"
                aria-hidden="true"
              >
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M19.0407 19.0407H16.0778V14.4C16.0778 13.2926 16.0593 11.8704 14.537 11.8704C12.9926 11.8704 12.7556 13.0778 12.7556 14.3222V19.0444H9.79259V9.4963H12.637V10.8H12.6778C13.0741 10.0481 14.0407 9.25926 15.4852 9.25926C18.4889 9.25926 19.0444 11.237 19.0444 13.8074V19.0407H19.0407ZM6.44815 8.19259C5.4963 8.19259 4.72963 7.42222 4.72963 6.47037C4.72963 5.52222 5.49963 4.75185 6.44815 4.75185C7.3963 4.75185 8.16667 5.52222 8.16667 6.47037C8.16667 7.42222 7.3963 8.19259 6.44815 8.19259ZM4.96667 19.0407H7.93333V9.4963H4.96667V19.0407ZM20.5185 2H3.47741C2.66296 2 2 2.64444 2 3.44074V20.5556C2 21.3519 2.66296 22 3.47741 22H20.5185C21.333 22 22 21.3519 22 20.5556V3.44074C22 2.64444 21.337 2 20.5185 2Z"
                ></path>
                <mask
                  className="social__links__icons-icon__mask0_0_1"
                  maskUnits="userSpaceOnUse"
                  x="2"
                  y="2"
                  width="20"
                  height="20"
                >
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M19.0407 19.0407H16.0778V14.4C16.0778 13.2926 16.0593 11.8704 14.537 11.8704C12.9926 11.8704 12.7556 13.0778 12.7556 14.3222V19.0444H9.79259V9.4963H12.637V10.8H12.6778C13.0741 10.0481 14.0407 9.25926 15.4852 9.25926C18.4889 9.25926 19.0444 11.237 19.0444 13.8074V19.0407H19.0407ZM6.44815 8.19259C5.4963 8.19259 4.72963 7.42222 4.72963 6.47037C4.72963 5.52222 5.49963 4.75185 6.44815 4.75185C7.3963 4.75185 8.16667 5.52222 8.16667 6.47037C8.16667 7.42222 7.3963 8.19259 6.44815 8.19259ZM4.96667 19.0407H7.93333V9.4963H4.96667V19.0407ZM20.5185 2H3.47741C2.66296 2 2 2.64444 2 3.44074V20.5556C2 21.3519 2.66296 22 3.47741 22H20.5185C21.333 22 22 21.3519 22 20.5556V3.44074C22 2.64444 21.337 2 20.5185 2Z"
                  ></path>
                </mask>
              </svg>
            </a>
          </li>
        </ul>

        <LogIn screenWidth="desktop" />
      </div>
    </div>
  );
}

export default Social;
